<template>
  <div>
    <h3>Submission Progress/Progrès des soumissions</h3>
    <table class="table table-sm table-bordered">
      <thead>
        <tr>
          <th></th>
          <th style="text-align: center;" colspan="3">Designated/Identified</th>
          <th style="text-align: center;" colspan="3">Non-Identified</th>
        </tr>
        <tr>
          <th>LHIN</th>
          <th style="text-align: center;">% in Dev.</th>
          <th style="text-align: center;">% Submitted</th>
          <th style="text-align: center;">% Evaluated</th>
          <th style="text-align: center;">% en dev.</th>
          <th style="text-align: center;">% Submitted</th>
          <th style="text-align: center;">% Evaluated</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for='lhin in data' :key='lhin.rliss_en'>
          <td v-text="lhin.rliss_en"></td>
          <td style="text-align: right;" v-text="percent(lhin.idDev,lhin.idTotal)"></td>
          <td style="text-align: right;" v-text="percent(lhin.idSoumis,lhin.idTotal)"></td>
          <td style="text-align: right;" v-text="percent(lhin.idEvalue,lhin.idTotal)"></td>
          <td style="text-align: right;" v-text="percent(lhin.niDev,lhin.niTotal)"></td>
          <td style="text-align: right;" v-text="percent(lhin.niSoumis,lhin.niTotal)"></td>
          <td style="text-align: right;" v-text="percent(lhin.niEvalue,lhin.niTotal)"></td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'ListeRliss',
  props: {
    data: Array
  },
  methods: {
    percent(a, b) {
      if(b==0) return "n/a";
      return (100*a/b).toFixed(1) + "%";
    }
  }
}
</script>
